import React from "react";
import DashboardCard from "./DashboardCard";
import AiAnalysisCard from "./AiAnalysisCard";
import ReviewGatheringCard from "./ReviewGatheringCard";
import CONSTANTS from "constants/constants";

const { MARKET_PULSE } = CONSTANTS;

const WhatIsMarketPulse = () => (
  <section className="what-is-marketpulse">
    <div className="what-is-marketpulse-title dvt-section-header mt1">
      <span className="what-is-marketpulse-title-highlight">{MARKET_PULSE.WHAT_TITLE_HIGHLIGHT}</span>{MARKET_PULSE.WHAT_TITLE}
    </div>
    {/* <div className=""> */}
      {/* <div className="what-is-marketpulse-left"> */}
        <DashboardCard />
        <AiAnalysisCard />
      {/* </div> */}
      {/* <div className="what-is-marketpulse-right"> */}
        <ReviewGatheringCard />
      {/* </div> */}
    {/* </div> */}
  </section>
);

export default WhatIsMarketPulse; 